jQuery(document).ready(function() {

    // Menu-Mobil-Click [Start]) //

    var contador = 1;
    var $hamburger = jQuery(".hamburger");
    $hamburger.on("click", function( event ) {

        event.preventDefault();
        $hamburger.toggleClass("is-active");

        if (contador==1) {
            jQuery('nav').animate ( { left: '0' } );
            contador = 0;
        } else {
            contador = 1;
            jQuery('nav').animate ( { left: '-100%' } );
        }

    });


	  // Show and hidden submenus [Start]) //
  	jQuery("li.submenu").click(function(e){
        e.stopPropagation(); // Prevents the event from bubbling up the DOM tree, preventing any parent handlers from being notified of the event.
        jQuery( this ).children('ul.children').slideToggle(100);
      }
  	);
    jQuery(".sub-menu-sub").click(
      function(e){
        e.stopPropagation();
        jQuery( this  ).children("ul.sub-children").slideToggle(100);
      }
  	);
    jQuery("li.submenu").hover(function(){
  			if (!window.matchMedia("(max-width: 1000px)").matches) {
  				jQuery( this ).children(".children").slideDown(100);
  			}
  		},
  		function(){
  			if (!window.matchMedia("(max-width: 1000px)").matches) {
  				jQuery( this ).children(".children").slideUp(100);
  			}
  		}
  	);
    jQuery(".sub-menu-sub").hover(function(){
			if (!window.matchMedia("(max-width: 1000px)").matches) {
				jQuery( this ).children(".sub-children").slideDown(100);
			}
		},
		function(){
			if (!window.matchMedia("(max-width: 1000px)").matches) {
				jQuery( this ).children(".sub-children").slideUp(100);
			}
		}
    );

});
